export default __webpack_public_path__ + "static/media/765.c0855f51.jpg";